import { createI18nText } from '@hilma/netina2all';

const changeStationText = createI18nText({
	he: {
		ok: 'אישור',
		next: 'הבא',
		back: 'חזור',
		order: 'הזמנה',
		selectOrders: 'בחר את ההזמנות שברצונך לאסוף בתחנה אחרת',
		updating: 'מעדכן',
		selectOrdersErr: 'אנא בחר לפחות הזמנה אחת'
	},
	en: {
		ok: 'Ok',
		next: 'Next',
		back: 'Back',
		order: 'Order',
		selectOrders: 'Please select the orders you would like to change their pick up station',
		updating: 'Updating',
		selectOrdersErr: 'Please select at least one order'
	}
});

export default changeStationText;